/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Case } from '../../models/case';
import { CaseUpdateRequest } from '../../models/case-update-request';

export interface UpdateCase$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: CaseUpdateRequest
}

export function updateCase(http: HttpClient, rootUrl: string, params: UpdateCase$Params, context?: HttpContext): Observable<StrictHttpResponse<Case>> {
  const rb = new RequestBuilder(rootUrl, updateCase.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Case>;
    })
  );
}

updateCase.PATH = '/api/v1/cases/{id}';
